/* DEPRECATED! SHOULD BE REMOVED */
export const EXPIRE_TIMEOUT = 60 * 10 * 1000
